import { gql } from "@apollo/client";

export default gql`
  mutation MarkAsViewed($id: String!) {
    markAsViewed(id: $id)
  }
`;
